export enum BusyStates {
    Login = "Login",
    ChangePasswordForm = "ChangePasswordForm",
    Document = "Document",
    Settings = "Settings",
    UserAccounts = "UserAccounts",
    Email = "Email"
}